import "./Footer.scss";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { ReactComponent as BoardActive } from "../../assets/images/FooterBoardActive.svg";
import { ReactComponent as Board } from "../../assets/images/FooterBoardInactive.svg";
import { ReactComponent as JobsActive } from "../../assets/images/FooterJobsActive.svg";
import { ReactComponent as Jobs } from "../../assets/images/FooterJobsInactive.svg";
import { ReactComponent as MessagesActive } from "../../assets/images/FooterMessagesActive.svg";
import { ReactComponent as Messages } from "../../assets/images/FooterMessagesInactive.svg";
import Button from "../essentials/button/Button";
import { selectUser } from "../../core/auth/authSlice";
import { User } from "../../shared/models";

const Footer: React.FC<{
  className?: string;
  children?: any;
}> = ({ className, children }) => {
  //   const dispatch = useDispatch();

  //   const { profileBadge } = useSelector((state: any) => state.Reducer);

  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedBtn, setSelectedBtn] = useState(location.pathname);
  const user = useSelector(selectUser) as User;
  const unreadCount = user?.unreadMessagesCount || 0;

  return (
    <>
      <div className="footer d-md-none">
        <div className="d-flex column center w-100">
          <Button
            className="btn"
            action={() => {
              navigate("/board");
              setSelectedBtn("board");
            }}
          >
            {selectedBtn.includes("board") ? (
              <BoardActive className="footer__icon" />
            ) : (
              <Board className="footer__icon" />
            )}
          </Button>
          <label htmlFor="">{t("header.nav.board")}</label>
        </div>

        <div className="d-flex column center w-100">
          <Button
            className="btn"
            action={() => {
              navigate("/jobs");
              setSelectedBtn("jobs");
            }}
          >
            {selectedBtn.includes("jobs") ? (
              <JobsActive className="footer__icon" />
            ) : (
              <Jobs className="footer__icon" />
            )}
          </Button>

          <label htmlFor="">{t("header.nav.jobs")}</label>
        </div>

        <div className="d-flex column center w-100 position-relative">
          <Button
            className="btn position-relative"
            action={() => {
              navigate("/messages");
              setSelectedBtn("messages");
            }}
          >
            {selectedBtn.includes("messages") ? (
              <MessagesActive className="footer__icon" />
            ) : (
              <Messages className="footer__icon" />
            )}
          </Button>
          {unreadCount && unreadCount > 0 ? (
            <span className="footer__badge">{unreadCount}</span>
          ) : null}
          <label htmlFor="">{t("header.nav.messages")}</label>
        </div>
      </div>
    </>
  );
};

export default Footer;
